import React, { FunctionComponent } from 'react'

import spotifyIcon from 'Shared/img/spotify-icon.png'

import { CheckTrackFromSearchProps } from './CheckTrackFromSearchProps'

import {
  SearchResults,
  SearchResultsItem,
  SearchResultsImg,
  SearchResultsText,
  SearchResultsTitle,
  SearchResultsDescription,
} from './styles'

const CheckTrackFromSearch: FunctionComponent<CheckTrackFromSearchProps> = ({
  onCheck,
  tracks,
}) => {
  if (tracks && tracks.length === 0) return null

  return (
    <SearchResults>
      {tracks
        ?.filter(item => item !== null)
        .map(item => (
          <SearchResultsItem key={item.id} onClick={() => onCheck(item.href)}>
            {item.album.images.length > 0 && item.album.images.length >= 3 ? (
              <SearchResultsImg
                src={item.album.images[2].url}
                alt={item.name}
                width="40"
              />
            ) : (
              <SearchResultsImg
                src={spotifyIcon}
                alt={spotifyIcon}
                width="40"
              />
            )}
            <SearchResultsText>
              <SearchResultsTitle>{item && item.name}</SearchResultsTitle>
              <SearchResultsDescription>
                {item && item.artists[0].name}
              </SearchResultsDescription>
            </SearchResultsText>
          </SearchResultsItem>
        ))}
    </SearchResults>
  )
}

export default CheckTrackFromSearch
